import Lightbox, { Slide } from 'yet-another-react-lightbox'
import Prev from './Prev.svg'
import Next from './Next.svg'
import Close from './Close.svg'

import 'yet-another-react-lightbox/styles.css'
import styles from './styles.module.css'

interface Props {
  index: number
  open: boolean
  close?: () => void
  slides: Slide[]
}

const ImageLightbox = ({ index, open, close, slides }: Props) => {
  const iconStyle = { width: 40, height: 40 }
  const disableCarousel = slides.length === 1
  return (
    <Lightbox
      index={index}
      open={open}
      close={close}
      slides={slides}
      className={styles.lightbox}
      carousel={{
        finite: disableCarousel
      }}
      render={{
        ...(disableCarousel
          ? {
              iconPrev: () => null,
              iconNext: () => null
            }
          : {
              iconPrev: () => <img src={Prev} alt="Previous" style={iconStyle} />,
              iconNext: () => <img src={Next} alt="Next" style={iconStyle} />
            }),
        iconClose: () => <img src={Close} alt="Close" style={iconStyle} />
      }}
      controller={{
        closeOnBackdropClick: true
      }}
    />
  )
}

export default ImageLightbox
